import React, { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import LocalIP from "../../api/LocalIP";
import api from "../../interceptors/axios";
import { MdEmail } from "react-icons/md";
import { MdOutlineError } from "react-icons/md";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { toast } from "react-toastify";

const EmailVerification = () => {
  const [verificationStatus, setVerificationStatus] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
  const token = new URLSearchParams(location.search).get("token");
  const verifyEmail_URL = "/user/verifyEmail";

  useEffect(() => {
    const fetchData = async () => {
      try {
        // const { data } = await LocalIP.post(verifyEmail_URL, { token });
        const { data } = await api.post(LocalIP + verifyEmail_URL, { token });

        setVerificationStatus(data.status);
        toast.success(data.message);
        navigate("/");
      } 
      catch (err) {
        const errorMessage = err.response?.data?.message || "An unexpected error occurred during signup.";
        toast.error(errorMessage);
      }
      
    };

    fetchData();
  }, [token]);

  return (
    <div>
      {verificationStatus === true ? (
        <div
          className="grid grid-flow-row sm:grid-flow-col gap-0.5 font-inter min-h-screen relative"
          style={{
            background:
              "linear-gradient(146deg, rgba(23,39,92,1) 9%, rgba(26,45,97,1) 24%, rgba(27,49,100,1) 33%, rgba(58,138,165,1) 100%)",
            backgroundColor: "rgb(23,39,92)",
          }}
        >
          <div className="sm:col-span-12 md:col-span-6 flex justify-center items-center text-3xl rounded-xl p-2"></div>

          <div
            className="sm:col-span-6 flex justify-center items-center text-3xl p-2 border-l-2 relative"
            style={{ borderColor: "#214471" }}
          >
            <div className="w-full flex justify-center items-center">
              <div className="absolute inset-y-1/2 transform -translate-y-1/2 right-15 sm:right-25 w-2/3 bg-white rounded-lg h-2/3 flex flex-col justify-center items-center">
                <div className="flex justify-center items-center w-1/3 h-1/3 bg-blue-950 rounded-full">
                  <MdEmail style={{ color: "white", fontSize: "4em" }} />
                </div>
                <div className="text-center mt-8">
                  <p className="text-base mx-20 mb-5">
                    Email verification successful! You can now{" "}
                    <a href="/">login</a>.
                  </p>
                </div>

                <Link to={"/"}>
                  <p className="text-gray-400 text-base mt-3 font-semibold">
                    Skip, I’ll Confirm Later
                  </p>
                </Link>
              </div>
            </div>
          </div>
        </div>
      ) : (
        verificationStatus === false && (
          <div
            className="grid grid-flow-row sm:grid-flow-col gap-0.5 font-inter min-h-screen relative"
            style={{
              background:
                "linear-gradient(146deg, rgba(23,39,92,1) 9%, rgba(26,45,97,1) 24%, rgba(27,49,100,1) 33%, rgba(58,138,165,1) 100%)",
              backgroundColor: "rgb(23,39,92)",
            }}
          >
            <div className="sm:col-span-12 md:col-span-6 flex justify-center items-center text-3xl rounded-xl p-2"></div>

            <div
              className="sm:col-span-6 flex justify-center items-center text-3xl p-2 border-l-2 relative"
              style={{ borderColor: "#214471" }}
            >
              <div className="w-full flex justify-center items-center">
                <div className="absolute inset-y-1/2 transform -translate-y-1/2 right-15 sm:right-25 w-2/3 bg-white rounded-lg h-2/3 flex flex-col justify-center items-center">
                  <div className="flex justify-center items-center w-1/3 h-1/3 rounded-full">
                    <MdOutlineError style={{ color: "red", fontSize: "4em" }} />
                  </div>
                  <div className="text-center">
                    <p className="text-xl font-semibold mb-3">Error !!!</p>

                    <p className="text-base mx-20 mb-5">Email Not Verified</p>
                  </div>
                  <Link to={"/"}>
                    <p className="text-gray-400 text-base mt-3">
                      Skip, to Login
                    </p>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        )
      )}
    </div>
  );
};

export default EmailVerification;
